<template>
  <div class="group w-[200px]">
    <div class="project-skeleton w-full h-[160px] rounded-lg" />
    <div class="project-skeleton w-full h-[20px] rounded-lg mt-5" />
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.project-skeleton {
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: projectPlaceholderAnimate;
  background: linear-gradient(
    90deg,
    rgba(65, 65, 65, 0) 0%,
    #9d9d9d 80px,
    rgba(65, 65, 65, 0) 160px
  );
}

@keyframes projectPlaceholderAnimate {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}
</style>
